import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tag, ArrowRight } from 'lucide-react';
import { brandsAPI, uploadsAPI } from '../services/api';
import { brandPath } from '../services/brandLogos';
import { useT } from '../services/i18n';

const MAX_BRANDS = 12;

const FooterBrands = () => {
  const { t } = useT();
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    brandsAPI.getAll()
      .then(list => setBrands(
        list.filter(b => b.product_count > 0)
          .sort((a, b) => (b.logo ? 1 : 0) - (a.logo ? 1 : 0) || b.product_count - a.product_count || a.name.localeCompare(b.name))
          .slice(0, MAX_BRANDS)
      ))
      .catch(() => setBrands([]));
  }, []);

  if (brands.length === 0) return null;

  return (
    <nav aria-label={t('fb.nav')} className="mt-10 pt-8 border-t border-gray-800" data-testid="footer-brands">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="font-semibold text-white flex items-center gap-2"><Tag size={16} className="text-orange-400" /> {t('fb.title')}</h3>
        <Link to="/marques" data-testid="footer-brands-all" className="text-sm text-gray-400 hover:text-orange-400 inline-flex items-center gap-1 transition-colors">
          {t('fb.all')} <ArrowRight size={14} />
        </Link>
      </div>
      <ul className="flex flex-wrap gap-2">
        {brands.map(b => (
          <li key={b.name}>
            <Link
              to={brandPath(b)}
              title={t('fb.parts', { b: b.name })}
              data-testid={`footer-brand-${b.name}`}
              className="h-10 px-3 inline-flex items-center justify-center rounded bg-white/95 hover:bg-white hover:ring-2 hover:ring-orange-400 transition-all"
            >
              {b.logo
                ? <img src={uploadsAPI.resolveUrl(b.logo)} alt={t('fb.logo', { b: b.name })} className="h-6 max-w-[88px] object-contain no-placeholder" data-testid={`footer-brand-logo-${b.name}`} />
                : <span className="text-xs font-bold text-gray-800 tracking-wide">{b.name}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FooterBrands;
